export const metricsDataSelector = (rootState) => rootState.metricsModel;
/* export const isMetricsLoadedSelector = ({ metricsModel: { isGTMLoaded, isYMLoaded } }: RootState) => isGTMLoaded && isYMLoaded; */
export const isMetricsLoadedSelector = ({ metricsModel: { isGTMLoaded } }) => isGTMLoaded;
